// extracted by mini-css-extract-plugin
export default {"link":"Link_link__RJVJ8","active":"Link_active__PZB2y"};